import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Layout from './components/Layout/Layout';
import Dashboard from './components/Dashboard/Dashboard';
import Clientes from './components/Clientes/Clientes';
import Pedidos from './components/Pedidos/Pedidos';
import Contas from './components/Contas/Contas';
import Login from './pages/Auth/Login';
import Planos from './pages/Planos';
import Equipamentos from './pages/Equipamentos';
import { Private } from './routes/Private';
import { Adm } from './routes/adm';
import CreateUsers from './pages/CreateUsers';
import { ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import TeamZap from './pages/TeamZap';

// Componente temporário para a página de configurações
const ConfiguracoesPage = () => (
  <div className="p-4">
    <h1>Configurações</h1>
    <p className="text-muted">Esta página está em desenvolvimento...</p>
  </div>
);

function App() {
  return (
    <>
    <ToastContainer position="top-right" autoClose={3000}  />
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />
        
        <Route path="/dashboard" element={
          <Private>
            <Layout>
            <Dashboard />
          </Layout>
          </Private>
        } />
        <Route path="/planos" element={
          <Private>
            <Layout>
              <Planos/>
            </Layout>
          </Private>
        } />
        
        <Route path="/clientes" element={
          <Private>
            <Layout>
              <Clientes/>
            </Layout>
          </Private>          
        } />

        <Route path="/createuser" element={
          <Private>
            <Adm>
              <Layout>
                <CreateUsers/>
              </Layout>
            </Adm>
          </Private>          
        } />
        
        <Route path="/pedidos" element={
          <Private>
            <Layout>
              <Pedidos/>
            </Layout>
          </Private>   
        } />
        
        <Route path="/contas" element={
          <Private>
            <Layout>
              <Contas/>
            </Layout>
          </Private>   
        } />

        <Route path="/equipamentos" element={
          <Private>
            <Layout>
              <Equipamentos/>
            </Layout>
          </Private>   
        } />

        <Route path="/teamzap" element={
          <Private>
            <Layout>
              <TeamZap/>
            </Layout>
          </Private>   
        } />
      </Routes>

    </Router>
    </>
  );
}

export default App;
